import React, { useState, useEffect, useRef } from 'react';
import AudioPlayer from './AudioPlayer'
import ImageButton from './imageButton';




const AudioRecorder = ({roomId, channel, uid, user_name, isFeedbackMaster, 
                        server_host, isFeedbackRunning, isPauseRunning, isRipRunning, setSpeaking}) => {
  const mediaRecorderRef = useRef(null);
  const analyserRef = useRef(null);
  const audioContextRef = useRef(null);
  const audioChunksRef = useRef([]);
  const audioPlayerRef = useRef(null);
  const [phoneMode, setPhoneMode] = useState(false)
  const phoneModeRef = useRef(phoneMode)
  const [mutePhone, setMutePhone] = useState(true)
  const mutePhoneRef = useRef(mutePhone)
  const [isResourced, setIsResourced] = useState(false)
  const receivedAudiosRef = useRef([])
  const gainNodeRef = useRef([])

  const speechEndTimeoutRef = useRef(null);
  const isStoring = useRef(false);


    
const record_mime = 'audio/webm;codecs="opus"'
const render_mime = 'audio/webm'
const render_ftyp = '.webm'
const audio_recordtime = 75
const nb_silent_cut = 4 // the number of consecutive silent chuncks necessary to send à phone message
const max_nb_chuncks = 60  // 45s max for audio blobs

const recorder_options = {
          mimeType: record_mime,
          sampleRate: 48000,
          noiseSuppression: false,
          volume : 2.0,
          numberOfAudioChannels: 2, // Set to 1 for mono recording
          audioBitsPerSecond: 120000,
          ignoreMutedMedia: true
        }

useEffect(() => {
  if (isResourced || mediaRecorderRef.current !== null) {
      phoneModeRef.current = false
      mutePhoneRef.current = true
      return
  }
  let mediaStream = null
  navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          mediaStream = stream
         receivedAudiosRef.current = []
          audioContextRef.current = new  window.AudioContext();
          analyserRef.current = audioContextRef.current.createAnalyser();
          // analyserRef.current.fftSize = 2048;

           // Créer un nœud de suppression de l'écho et du bruit de fond
          const echoSuppressor = audioContextRef.current.createBiquadFilter();
          echoSuppressor.type = 'highpass';
          echoSuppressor.frequency.value = 200; // Fréquence de coupure pour supprimer les basses fréquences
          
          // Connecter le stream audio au nœud de suppression
          const source = audioContextRef.current.createMediaStreamSource(stream);
          // source.connect(echoSuppressor).connect(analyserRef.current)
          source.connect(analyserRef.current)
          //.connect(audioContextRef.current.destination)


          // Connecter le flux audio du MediaRecorder à l'AnalyserNode


          mediaRecorderRef.current = new MediaRecorder(source.mediaStream,  recorder_options);
          audioPlayerRef.current = new Audio()
          setIsResourced(true)
          gainNodeRef.current = audioContextRef.current.createGain();
        })
        .catch((error) => {
          console.error('Erreur lors de l\'accès au microphone :', error);
        });
    // cleanup au démontage

          return () => {
            // Arrêter tous les tracks
            /*
            mediaStream.getTracks().forEach(track => {
              track.stop();
              console.log('🔴 Track arrêté:', track.kind);
            });
        */
            // mediaRecorderRef.current = null; won't be reinit by the way
            // setIsResourced(false)
            setMutePhone(true)
            setPhoneMode(false)
            phoneModeRef.current = false
            mutePhoneRef.current = true
            console.log('🔴 Micro libéré au démontage');
          };

/*
  channel.on('phone broadcast' , async ({room, username, stamp, audioSegment, audio_type, size}) => {
  let to_play = true
  // in prod mode, the following line mus be uncommented
  to_play = username !== user_name
  if (room === roomId && to_play && phoneMode){

    if ( ! receivedAudiosRef.current.includes(stamp)){

      receivedAudiosRef.current.push(stamp)
      // const audiotest = document.createElement('audio');
      // console.log('WebM:', audiotest.canPlayType('audio/webm'));

      const blob = new Blob([audioSegment], {type : audio_type})
      setSpeaking(username + '...')

      local_play_blob_as_url(blob)

    }
    if (receivedAudiosRef.current.length > 300){
      receivedAudiosRef.current = receivedAudiosRef.current.slice(-50)
    }
  }
});
*/
}, []);

 const downloadRecordedAudio = (blob) => {
    const audioUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = audioUrl;
    link.download = 'recorded_audio_' + Date.now().toString() + '.webm';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    phoneModeRef.current = phoneMode;
  }, [phoneMode]);

  useEffect(() => {
    mutePhoneRef.current = mutePhone;
  }, [mutePhone]);


  useEffect(() => {

  const resetSpeechEndTimeout = () => {
  if (speechEndTimeoutRef.current) {
      clearTimeout(speechEndTimeoutRef.current);
    }
    speechEndTimeoutRef.current = setTimeout(() => {
      // everything treated on recorder stop
        mediaRecorderRef.current.stop()

    }, nb_silent_cut * audio_recordtime); // Considérer la fin de la parole après 2 périodes de silence
  };


  function hasVoice() {
    const dataArray = new Uint8Array(analyserRef.current.frequencyBinCount);
    analyserRef.current.getByteTimeDomainData(dataArray);
    let isVoice = false;
    for (let i = 0; i < analyserRef.current.frequencyBinCount; i+=1) {
      // Détecter la présence de voix en analysant le signal temporel
      if (dataArray[i] < 125 || dataArray[i] > 128) {
        isVoice = true;
        break;
      }
    }
    return isVoice
  }


  if (mediaRecorderRef.current) {
          mediaRecorderRef.current.ondataavailable = (event) => {
            // console.log('Audio capture evt');
           //   if (!capturedAudiosRef.current.includes(event.timeStamp)) {
           //       capturedAudiosRef.current.slice(-20).push(event.timeStamp)
           //    }
           if (mutePhoneRef.current) {
            return
           }
           const isVoice = hasVoice(event.data)
            if (isVoice ||  audioChunksRef.current.length === 0) {
              audioChunksRef.current.push(event.data);
            }
            if (hasVoice(event.data) && audioChunksRef.current.length < max_nb_chuncks ) {
                resetSpeechEndTimeout()
            }            
          };

          mediaRecorderRef.current.onstart = () => {
            audioChunksRef.current = []
          }

          mediaRecorderRef.current.onstop = async () => {
            if (!phoneModeRef.current) {
              return
            }
            if (mutePhoneRef.current) {
              return
            }
            if(audioChunksRef.current.length > 1) {
              /*
              while (mediaRecorderRef.current.state === 'recording') {
                setTimeout(() => {
                  console.log('waiting for stopped recording')
                }, 0.8 * audio_recordtime);
              } // Considérer la fin de la parole après 2 périodes de silence
               */
              const blob = new Blob(audioChunksRef.current, {type : render_mime})
              send_audio(blob, Date.now().toString())
              // local_play_blob_as_url(blob)
              // downloadRecordedAudio(blob)
            }
            mediaRecorderRef.current.start(audio_recordtime)
        };

          mediaRecorderRef.current.onend = () => {  // never used
            mediaRecorderRef.current.start(audio_recordtime);
            console.log('Audio capture restart');
          };
        }
  }, [phoneMode, mutePhone]);


function local_store_blob(blob, name) {
      const audioUrl = URL.createObjectURL(blob)
      const downloadLink = document.createElement('a');
      downloadLink.download = name + render_ftyp;
      downloadLink.href = audioUrl;
      try {
          document.body.appendChild(downloadLink);
          downloadLink.click()
          console.log('saved chunck')
          URL.revokeObjectURL(audioUrl)
       } catch (error) {
              URL.revokeObjectURL(audioUrl)
              console.log('error saving chunck')
        }

      document.body.removeChild(downloadLink);

}

function local_store_chuncks(fid) {
  let i = 0
  audioChunksRef.current.forEach((c) => {
    const blob1 = new Blob([audioChunksRef.current[i]], {type : record_mime})
    const blob = new Blob([blob1], {type : render_mime})
    local_store_blob(blob,  'audio_full_' + fid + '_chunck_' + i)
    i += 1
  });
    
}


async function treat_audio() {
    
      if (isStoring.current || audioChunksRef.current.length == 0) {
        // console.log('empty chuncks file')
        return
      }
      isStoring.current = true
      const fid = Date.now().toString()
      // const blob1 = new Blob([audioChunksRef.current[0]], {type : record_mime})
      // const blob1 = new Blob(audioChunksRef.current.slice(0, audioChunksRef.current.length - 1), {type : record_mime})
      const blob1 = new Blob(audioChunksRef.current, {type : render_mime})
      console.log('preparing blob')
      const blob = new Blob([blob1], {type : render_mime})
      isStoring.current = false
      // await send_audio(blob1, fid)
      local_store_blob(blob1, 'audio_full_' + fid)
      // local_store_chuncks(fid)
      // play_blob_as_source(blob)

  }

  async function send_audio(audioBlob, stamp) {
      const arrayBuffer = await audioBlob.arrayBuffer();
      const phoneMsg = {
          'room' : roomId, 
          'username': user_name, 
          'stamp' : stamp,
          'audioSegment' : arrayBuffer,
          'contentType' : audioBlob.type,
          'size' : arrayBuffer.byteLength
          } 
      if ((phoneModeRef.current) && (!mutePhoneRef.current)){
        channel.emit('phone message', phoneMsg)    
      }
    }
 
/*
async function convertWebMToMP3(webmBlob) {
  ffmpeg.FS('writeFile', 'input.webm', await fetchFile(webmBlob));
  await ffmpeg.run('-i', 'input.webm', '-acodec', 'mp3', 'output.mp3');
  const mp3Data = ffmpeg.FS('readFile', 'output.mp3');
  return mp3Data.buffer
}
*/
async function local_play_blob(blob) {
      if (audioPlayerRef.current != null && audioPlayerRef.current.currentTime != 0){
            audioPlayerRef.current.pause();
            audioPlayerRef.current.currentTime = 0;
      }

      // audioPlayerRef.current = new Audio();
      audioPlayerRef.current.type = render_mime;
      try {
        const arrayBuffer = await blob.arrayBuffer();
        const audioBuffer = await audioContextRef.current.decodeAudioData(arrayBuffer);
              // Créer une source audio
        const source = audioContextRef.current.createBufferSource();
        source.buffer = audioBuffer;      
        gainNodeRef.current.value = 1
        try {
          source.connect(audioContextRef.current.destination);
          
          // Jouer l'audio
          source.start();
        } catch (error) {
            console.log('problème de lecture audio ' + error.message)
            audioPlayerRef.current.currentTime = 0
            audioPlayerRef.current.src = null
            audioPlayerRef.current.pause()
        }
        // WebM worked!
      } catch (error) {
        /*
        // Convert to MP3/WAV and try again
        const mp3Buffer = await convertWebMToMP3(blob);
        // const arrayBuffer = await convertedBlob.arrayBuffer();
        const audioBuffer = await audioContextRef.current.decodeAudioData(mp3buffer);
        */
       console.log('error with blob, unable to decode audio format')
       return
      }  
}

async function local_play_blob_as_url(blob) {
      const audioUrl = URL.createObjectURL(blob)
      

      if (audioPlayerRef.current != null && audioPlayerRef.current.currentTime != 0){
            audioPlayerRef.current.pause();
            audioPlayerRef.current.currentTime = 0;
      }

      // audioPlayerRef.current = new Audio();
      audioPlayerRef.current.type = render_mime;
      audioPlayerRef.current.src = audioUrl;
      gainNodeRef.current.value = 3
      try {
        audioPlayerRef.current.addEventListener('canplaythrough', () => {
          console.log("Audio supporté, lecture possible.");
          audioPlayerRef.current.play().catch(err => {
            console.error("Erreur au démarrage de la lecture :", err);
          });
        });
        audioPlayerRef.current.addEventListener('error', function () {
          const error = audioPlayerRef.current.error;
          if (error) {
            switch (error.code) {
              case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
                  console.error("Erreur : format ou source non supporté.");
                  break;
              case MediaError.MEDIA_ERR_ABORTED:
                  console.error("Erreur : chargement annulé.");
                  break;
              case MediaError.MEDIA_ERR_NETWORK:
                  console.error("Erreur : problème réseau.");
                  break;
              case MediaError.MEDIA_ERR_DECODE:
                  console.error("Erreur : problème de décodage.");
                  break;
              default:
                  console.error("Erreur inconnue.");
            }
          }
        });

        audioPlayerRef.current.addEventListener('ended', () => {
            // console.log('La lecture du fichier audio est terminée');
             // Effectuer d'autres actions ici
            URL.revokeObjectURL(audioPlayerRef.current.src)
            setSpeaking('  ')
            });
        audioPlayerRef.current.load()
      } catch (error) {
        console.log('problème de lecture audio ' + error.message)
        audioPlayerRef.current.currentTime = 0
        audioPlayerRef.current.src = null
        audioPlayerRef.current.pause()
        URL.revokeObjectURL(audioUrl)
      }
}

async function play_blob_as_source(blob) {
      const audioUrl = URL.createObjectURL(blob)
      const audio = new Audio(audioUrl)
      audio.addEventListener('ended', () => {
        // URL.revokeObjectURL(audioUrl)
        console.log ('should revoke')
      })
      const source = await audioContextRef.current.createMediaElementSource(audio)
      await source.connect(audioContextRef.current.destination);
      await audio.play()
 }

async function play_audio(audioData, order) {
    
      if (! phoneMode){
        return
      }
      const blob1 = new Blob([audioData], {type : record_mime})
      const blob = new Blob([blob1], {type : render_mime})
      play_blob_as_source(blob)
  }


  const handleMute = (e) => { 
    const mute = !mutePhone
    if (mute) {
      channel.emit('mic off', uid)
    } else {
      channel.emit('mic on', uid)
    }
    setMutePhone(mute)

  };

  const handlePhone = (e) => {
    const phone = !phoneMode
    setPhoneMode(phone)
    if (phone) {
      mediaRecorderRef.current.start(audio_recordtime)
      channel.emit('phone on', uid)
    } else {
       setSpeaking('')
       setMutePhone(true)
       channel.emit('phone off', uid)
       mediaRecorderRef.current.stop()
    }
  };

  let protocol = process.env.REACT_APP_PROTOCOL
  if (protocol === undefined){
    protocol = "http"
  }



  return (
    <div>
      {isResourced && ! isRipRunning && 
          (! isFeedbackRunning || isFeedbackMaster) 
          && !isPauseRunning && phoneMode && ! mutePhone? (
          <ImageButton
                url={`${protocol}://${server_host}:3050/images/mic-off.svg`} onClick={handleMute} size='tiny' 
                                                  color='rgb(255, 85, 85)' title="Ne plus transmettre, mais entendre"/>
         )
          : ( '')}  
      {isResourced && ! isRipRunning && 
          (! isFeedbackRunning || isFeedbackMaster) 
          && !isPauseRunning && phoneMode && mutePhone? (
          <ImageButton
                url={`${protocol}://${server_host}:3050/images/mic.svg`} color='rgb(85, 255, 85)' onClick={handleMute} size='tiny' 
                                                   title="Transmettre l'audio"/>
         )
          : ( '')}  
      {isResourced && ! isRipRunning && 
          (! isFeedbackRunning || isFeedbackMaster) 
          && !isPauseRunning && phoneMode ? (
          <AudioPlayer channel={channel} user_name={user_name} roomId={roomId} setSpeaking={setSpeaking}/>
         )
          : ( '')}  
      {isResourced && ! isRipRunning && 
          (! isFeedbackRunning || isFeedbackMaster)
           && !isPauseRunning && ! phoneMode ? (
            <ImageButton
              url={`${protocol}://${server_host}:3050/images/phone.svg`} onClick={handlePhone} size='small'title="Ecouter, si d'autres transmettent l'audio (Pas d'enregistrement)" 
               color='#55FF55'/>
          )
          : ( '')}      
      {isResourced && ! isRipRunning && 
          (! isFeedbackRunning || isFeedbackMaster) 
          && !isPauseRunning && phoneMode ? (
          <ImageButton
                url={`${protocol}://${server_host}:3050/images/phone-off.svg`} onClick={handlePhone} size='small' 
                                                  color='rgb(255, 85, 85)' title="Ne plus transmettre l'audio, ne plus l'écouter"/>
         )
          : ( '')}  
    </div>
  );
};

export default AudioRecorder;